import { render } from "./RawCustomDataTableWidgetDataConfig.vue?vue&type=template&id=06f81455&scoped=true"
import script from "./RawCustomDataTableWidgetDataConfig.vue?vue&type=script&lang=ts"
export * from "./RawCustomDataTableWidgetDataConfig.vue?vue&type=script&lang=ts"

import "./RawCustomDataTableWidgetDataConfig.vue?vue&type=style&index=0&id=06f81455&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06f81455"

export default script